import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material';
import COLORS from '../../../../resources/style/Themes';

const ConfirmFreeTrialModal = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          backgroundColor: COLORS.SAFEGUARD_BLUE,
          color: COLORS.WHITE,
        }}
      >
        Confirm Free Trial
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <br></br>
          This organization will have unlimited available seats through the
          duration of their free trial.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            borderRadius: '10px',
            height: '42px',
            paddingBottom: 1,
            textAlign: 'center',
            justifyContent: 'center',
            border: 'none',
            backgroundColor: COLORS.SAFEGUARD_ORANGE,
            color: COLORS.WHITE,
            '&:hover': {
              backgroundColor: COLORS.SAFEGUARD_ORANGE,
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          sx={{
            borderRadius: '10px',
            height: '42px',
            paddingBottom: 1,
            textAlign: 'center',
            justifyContent: 'center',
            border: 'none',
            backgroundColor: COLORS.SAFEGUARD_ORANGE,
            color: COLORS.WHITE,
            '&:hover': {
              backgroundColor: COLORS.SAFEGUARD_ORANGE,
            },
          }}
          autoFocus
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmFreeTrialModal;
